'use strict';

(function () {
    'use strict';

    translationsConfig.$inject = ['$translateProvider'];
    angular.module('app.admin').config(translationsConfig);

    /* @ngInject */
    function translationsConfig($translateProvider) {

        $translateProvider.translations('el', {
            'admin': {
                'alert': {
                    'description': 'description_el'
                },
                'alert-group': {
                    'description': 'description_el'
                },
                'parking': {
                    'description': 'description_el',
                    'filters': {
                        'All': 'Όλες',
                        'Free': 'Ελεύθερες',
                        'Occupied': 'Κατειλλημένες',
                        'Offline': 'Εκτός λειτουργίας'
                    },
                    'status': {
                        'Free': 'Ελεύθερη',
                        'Occupied': 'Κατειλλημένη',
                        'Offline': 'Εκτός λειτουργίας'
                    },
                    'since': 'από',
                    'Last change': 'Τελευταία αλλαγή',
                    'last change': 'τελευταία αλλαγή',
                    'Name': 'Όνομα',
                    'Status': 'Κατάσταση',
                    'Since': 'Από',
                    'Last update': 'Τελευταία ενημέρωση'
                },

                'gateway': {
                    'Online': 'Σε λειτουργία',
                    'Offline': 'Εκτός λειτουργίας'
                },
                'device': {
                    'Online': 'Σε λειτουργία',
                    'Offline': 'Εκτός λειτουργίας'
                },
                'analytics-mode': {
                    'name': 'name_el'
                },
                'login': {
                    'Welcome,': 'Καλωσόρισες,',
                    'Login': 'Είσοδος',
                    'Logout': 'Αποσύνδεση',
                    'Sign in': 'Είσοδος',
                    'Email address': 'Διεύθυνση ηλ. ταχυδρομείου',
                    'Password': 'Σύνθημα',

                    'Sorry, we could not log you in.': 'Δεν ήταν δυνατή η είσοδός σας στο σύστημα.'
                },
                'iot-status': {
                    'Gateway': 'Πύλη δικτύου (Gateway)',
                    'Alerts (today)': 'Ειδοποιήσεις (σήμερα)',
                    'Status': 'Κατάσταση',
                    'Since': 'Από'
                },
                'iot-map': {
                    'see more': 'περισσότερα...',
                    'Gateways': 'Πύλες δικτύου (Gateway)',
                    'Devices': 'Συσκευές',
                    'All': 'Όλες',
                    'Urban environment': 'Αστικό περιβάλλον',
                    'Water resources': 'Υδάτινο περιβάλλον',
                    'Parking': 'Στάθμευση',
                    'Alerts (today)': 'ειδοποιήσεις (σήμερα)',
                    'since': 'από',
                    'Online': 'Σε λειτουργία',
                    'Offline': 'Εκτός λειτουργίας'
                },
                'gateway-status': {
                    'Online': 'Σε λειτουργία',
                    'Offline': 'Εκτός λειτουργίας',
                    'since': 'από',
                    'Devices': 'Συσκευές',
                    'Dashboard': 'Πίνακας ελέγχου',
                    'Latest values': 'Πρόσφατες τιμές'
                },
                'device-status': {
                    'Online': 'Σε λειτουργία',
                    'Offline': 'Εκτός λειτουργίας',
                    'Dashboard': 'Πίνακας ελέγχου',
                    'Sensors': 'Αισθητήρες',
                    'Latest values': 'Πρόσφατες τιμές',
                    'alerts': 'ειδοποιήσεις',
                    'No Value': 'Χωρίς τιμή',
                    'Normal': 'Κανονική λειτουργία'
                }
            }
        });
    }
})();